import React from 'react';
import { FadeIn, Section } from './Shared';
export const ObjectionsSection = () => {
  const objections = [{
    q: '“No tengo tiempo”',
    a: 'El protocolo se adapta a tu rutina diaria.'
  }, {
    q: '“No quiero hacer dieta”',
    a: 'Esto no es una dieta. Es un reinicio metabólico.'
  }, {
    q: '“Ya probé todo”',
    a: 'Nunca trataste el problema real: tu hígado.'
  }];
  return <Section bg="cream" data-id="element-215">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-216">
        {objections.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-217">
            <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row gap-3 md:items-center" data-id="element-218">
              <div className="md:w-1/3" data-id="element-219">
                <h3 className="text-xl font-bold text-gray-400 italic" data-id="element-220">
                  {item.q}
                </h3>
              </div>
              <div className="hidden md:block w-px h-12 bg-gray-200" data-id="element-221"></div>
              <div className="md:w-2/3" data-id="element-222">
                <p className="text-xl text-brand-charcoal font-medium" data-id="element-223">
                  {item.a}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};